import { RollAnalyzerService } from './generated/services/RollAnalyzerService';
import type { BatchAnalysisResponse } from './generated/models/BatchAnalysisResponse';
import type { RecordOutcomeRequest } from './generated/models/RecordOutcomeRequest';
import type { RecordOutcomeResponse } from './generated/models/RecordOutcomeResponse';
import type { RollAnalyzerRequest } from './generated/models/RollAnalyzerRequest';
import type { RollAnalyzerResponse } from './generated/models/RollAnalyzerResponse';
import type { UpdateWeightsRequest } from './generated/models/UpdateWeightsRequest';
import type { WeightsResponse } from './generated/models/WeightsResponse';

export function analyzeRollPosition(
  requestBody: RollAnalyzerRequest
): Promise<RollAnalyzerResponse> {
  return RollAnalyzerService.analyzePositionApiV1RollAnalyzerAnalyzePost({
    requestBody,
  });
}

export function analyzeRollPositionsBatch(
  createSnapshots = true
): Promise<BatchAnalysisResponse> {
  return RollAnalyzerService.analyzePositionsBatchApiV1RollAnalyzerBatchPost({
    createSnapshots,
  });
}

export function recordRollOutcome(
  requestBody: RecordOutcomeRequest
): Promise<RecordOutcomeResponse> {
  return RollAnalyzerService.recordOutcomeApiV1RollAnalyzerRecordOutcomePost({
    requestBody,
  });
}

export function updateRollWeights(
  requestBody?: UpdateWeightsRequest | null
): Promise<WeightsResponse> {
  return RollAnalyzerService.updateWeightsApiV1RollAnalyzerUpdateWeightsPost({
    requestBody,
  });
}

export function getRollWeights(
  strategyBucket?: string | null
): Promise<WeightsResponse> {
  return RollAnalyzerService.getWeightsApiV1RollAnalyzerWeightsGet({
    strategyBucket,
  });
}
